<template>
 <div class="modal zoom" tabindex="-1" role="dialog" id="modalEspontaneo"> 
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="fecharModal"><span aria-hidden="true">&times;</span></button>
        <h4 class="modal-title text-left">Formulário Espontâneo</h4> 
      </div>
      <div class="modal-body">  
        <div class="input-group">
          <input type="text" v-mask="'###.###.###-##'" class="form-control" placeholder="Digite o CPF" @keyup.enter="pesquisar" v-model="pesquisaView" >
          <span class="input-group-btn">
              <button class="btn btn-primary" type="button" @click="pesquisar">
                <span v-show="!loadPesquisa">Pesquisar</span>
                <i class="fa fa-circle-o-notch fa-spin" v-show="loadPesquisa"></i>   
              </button>
          </span>
        </div>
        <br /><br /> 
        <table v-show="resultadoPesquisa.length !== 0 && this.isSemCPF === false" class="table table-striped table-bordered">
          <thead>
              <tr> 
                  <td></td> 
                  <td>Nome</td>
                  <td>CPF</td>
              </tr>
          </thead>
          <tbody>
              <tr v-if="resultadoPesquisa.length !== 0" v-for=" row of resultadoPesquisa" :key="row"> 
                  <td><input type="checkbox" :value="row" title="Selecionar" v-model="agendamento"></td>     
                  <td class="text-left"><a target="_blank" :href="urlCurriculo + row.Guid" > {{ row.Nome }} </a> </td>
                  <td>{{ row.Cpf }}</td>
              </tr>   
              <tr v-else>
                  <td colspan="5">A pesquisa não retornou nenhum resultado.</td>
              </tr>
          </tbody>
        </table>  
        <div v-show="this.isSemCPF" style="margin-top:-25px;">
          <span style="float:left; margin-top:-10px;" class="label label-danger">Não encontramos esse CPF em nossa base de dados.</span> <br /> <br />
          <div  class="form-group"> 
            <input type="text" class="form-control" placeholder="Digite o Nome Completo" v-model="vNome" > 
          </div> 
          <span class="label label-default text-left" style="float:left; margin-top:-10px;">Preencha o nome completo e, depois, selecione o tipo de atendimento (Admissão, Rescisão ou Outros).</span> <br /> <br /> <br /> 
        </div> 
      <div class="form-group text-left">
        <label for="observacoes" class="col-sm-2 control-label">Observações</label>
        <textarea class="form-control" rows="3" id="observacoes" v-model="observacoes"></textarea>
      </div>  

      </div>
      <div class="modal-footer"> 
        <button type="button" class="btn btn-default" data-dismiss="modal" @click="fecharModal">Fechar</button>
        <button type="button" class="btn btn-alert" @click="outros">
          <span v-show="!loadOutros">Outros</span>
          <i class="fa fa-circle-o-notch fa-spin" v-show="loadOutros"></i>  
        </button>
        <button type="button" class="btn btn-danger" @click="rescisao">
          <span v-show="!loadRescisao">Rescisão</span>
          <i class="fa fa-circle-o-notch fa-spin" v-show="loadRescisao"></i> 
        </button>
        <button type="button" class="btn btn-info" @click="admissao">
          <span v-show="!loadAdmissao">Admissão</span>
          <i class="fa fa-circle-o-notch fa-spin" v-show="loadAdmissao"></i>
        </button>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->
</template>
<script>
export default{
  name: 'modalAgendar',
  created: function () {
    this.unidade = localStorage.getItem('Unidade')
    this.resultadoPesquisa = []
  },
  components: {
  },
  methods: {
    fecharModal () {
      this.resultadoPesquisa = []
      this.pesquisaView = ''
      this.observacoes = ''
    },
    admissao () {
      if (this.isSemCPF === true && (this.vNome === '' || this.pesquisaView === '')) {
        alert('Você deve preencher o CPF e o Nome')
        return false
      }
      if (this.vNome !== '') {
        this.agendamento = [{
          Nome: this.vNome,
          Cpf: this.pesquisaView,
          IdEmpresaFilial: 0
        }]
      }
      let opcaoColetivo = false
      if (this.agendamento.length > 1) {
        if (confirm('Você selecionou mais de uma pessoa. Deseja programar atendimento coletivo?')) {
          opcaoColetivo = true
        } else {
          opcaoColetivo = false
        }
      }
      this.loadAdmissao = true
      let agendamentos = {
        agendamento: this.agendamento,
        tipo: 0,
        coletivo: opcaoColetivo,
        espontaneo: true,
        observacoes: this.observacoes,
        unidade: this.unidade,
        IdUsuario: JSON.parse(localStorage.getItem('Usuario')).Usuario.Id
      }
      this.$http.post('agendamento/salvar', agendamentos)
      .then(function (res) {
        location.reload()
      })
      .catch(function (err) {
        this.loadAdmissao = false
        alert('Ops! - Algo de errado aconteceu.\nEntre em contato com a área de Projetos.')
        console.log(err)
      })
    },
    rescisao () {
      if (this.isSemCPF === true && (this.vNome === '' || this.pesquisaView === '')) {
        alert('Você deve preencher o CPF e o Nome')
        return false
      }
      if (this.vNome !== '') {
        this.agendamento = [{
          Nome: this.vNome,
          Cpf: this.pesquisaView,
          IdEmpresaFilial: 0
        }]
      }
      if (this.agendamento.length === 0) {
        alert('Você deve selecionar pelo menos uma pessoa')
        return false
      }
      this.loadRescisao = true
      let agendamentos = {
        agendamento: this.agendamento,
        tipo: 1,
        coletivo: false,
        espontaneo: true,
        observacoes: this.observacoes,
        unidade: this.unidade,
        IdUsuario: JSON.parse(localStorage.getItem('Usuario')).Usuario.Id
      }
      this.$http.post('agendamento/salvar', agendamentos)
      .then(function (res) {
        location.reload()
      })
      .catch(function (err) {
        this.loadRescisao = false
        alert('Ops! - Algo de errado aconteceu.\nEntre em contato com a área de Projetos.')
        console.log(err)
      })
    },
    outros () {
      if (this.isSemCPF === true && (this.vNome === '' || this.pesquisaView === '')) {
        alert('Você deve preencher o CPF e o Nome')
        return false
      }
      if (this.vNome !== '') {
        this.agendamento = [{
          Nome: this.vNome,
          Cpf: this.pesquisaView,
          IdEmpresaFilial: 0
        }]
      }
      if (this.agendamento.length === 0) {
        alert('Você deve selecionar pelo menos uma pessoa')
        return false
      }
      if (this.postFormulario.observacoes === '') {
        alert('Para "Outros" você deve preencher o campo "Observações"')
      } else {
        this.loadOutros = true
        let agendamentos = {
          agendamento: this.agendamento,
          tipo: 2,
          coletivo: false,
          espontaneo: true,
          observacoes: this.observacoes,
          unidade: this.unidade,
          IdUsuario: JSON.parse(localStorage.getItem('Usuario')).Usuario.Id
        }
        this.$http.post('agendamento/salvar', agendamentos)
        .then(function (res) {
          location.reload()
        })
        .catch(function (err) {
          this.loadOutros = false
          alert('Ops! - Algo de errado aconteceu.\nEntre em contato com a área de Projetos.')
          console.log(err)
        })
      }
    },
    pesquisar () {
      this.agendamento = []
      this.loadPesquisa = true
      this.isSemCPF = false
      this.$http.get('pesquisa?id=' + this.pesquisaView)
      .then(function (res) {
        if (res.body.length === 0) {
          this.isSemCPF = true
          this.loadPesquisa = false
        } else {
          this.resultadoPesquisa = res.body
          this.loadPesquisa = false
        }
      })
      .catch(function (err) {
        this.loadPesquisa = false
        alert('Ops! - Algo de errado aconteceu.\nEntre em contato com a área de Projetos.')
        console.log(err)
      })
    }
  },
  computed: {
    postFormulario: function () {
      return {
        dia: this.diaView,
        hora: this.horaView,
        observacoes: this.observacoes,
        selecionados: this.chk
      }
    },
    postPesquisa: function () {
      return {
        id: this.pesquisaView
      }
    },
    urlCurriculo: function () { return 'http://fastrhluandre.com.br/Curriculo/Visualizar/?confidencial=false&imprimir=true&guid=' },
    urlFicha: function () { return 'http://fastrhluandre.com.br/FichaAprovacao/Visualizar/' },
    urlVaga: function () { return 'http://fastrhluandre.com.br/Vagas/Visualizar/' }
  },
  data () {
    return {
      resultadoPesquisa: [],
      pesquisaView: '',
      diaView: '',
      horaView: '',
      observacoes: '',
      agendamento: [],
      unidade: '',
      vNome: '',
      isSemCPF: false,
      loadPesquisa: false,
      loadAdmissao: false,
      loadRescisao: false,
      loadOutros: false
    }
  },
  props: ['dia', 'hora']
}
</script>
<style scoped>
.btn{
  min-width:100px;
}
</style>



// WEBPACK FOOTER //
// Espontaneo.vue?d81326d6